import wx from 'weixin-js-sdk'
import api from '../../api'

var jsapiConfigure = {
    ensureParams(){
        return new Promise((resolve, reject) => {
            console.log('params', this._params)
            if (this._params) {
                return resolve(this._params)
            }
            this.refreshParams().then(params => {
                this._params = params
                resolve(params)
            })
        })
    },
    config(){
        //console.log('config2')

        this.ensureParams().then(params => {
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: params.appId, // 必填，公众号的唯一标识
                timestamp: params.timestamp, // 必填，生成签名的时间戳
                nonceStr: params.nonceStr, // 必填，生成签名的随机串
                signature: params.signature,// 必填，签名
                jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "chooseImage", "previewImage", "uploadImage","getLocation","scanQRCode"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
        })
    },
    refreshParams(){
        var location = document.location;
        var url = `${location.origin}${location.pathname || ''}${location.search || ''}`
        // var url =location.href
        console.log('local',location.href)
        return api.wx.jsapiParams(url)
            .then(params => {
                console.log('5555',params)
                this._params = params
                return params
            })
    },
    checkTimes(){
      let times = localStorage.getItem("refreshJsApiTimes");
      //console.log("times", times);
      if(!times){
        localStorage.setItem("refreshJsApiTimes", 0);
        return true;
      }
      let t = parseInt(times+"");
      if(t >= 3){
        return false;
      }
      t++;
      localStorage.setItem("refreshJsApiTimes", t);
      return true;
    }

}

wx.error(res => {
    //console.error('wx.error', res);
    if(jsapiConfigure.checkTimes()){
      jsapiConfigure.refreshParams().then(() => {
        jsapiConfigure.config()
      })
    }
});

export default {
    config(){
        //console.log('config1')
        jsapiConfigure.config()
    },
    chooseImage(maxCount) {
        return new Promise((resolve, reject) => {
            wx.chooseImage({
                count: maxCount || 1, // 默认9
                sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                success(res) {
                    resolve(res.localIds);// 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                }
            })
        })
    },
    uploadImage(file) {
        return new Promise((resolve, reject) => {
            wx.uploadImage({
                localId: file, // 需要上传的图片的本地ID，由chooseImage接口获得
                isShowProgressTips: 1, // 默认为1，显示进度提示
                success (res) {
                    resolve(res.serverId);// 返回图片的服务器端ID
                }
            })
        })
    },
    isMedia(mediaId){
        if(!mediaId){
            return false;
        }
        return mediaId.indexOf("/") < 0;
    },
    shareTimeline(initObj){
        return new Promise((resolve, reject) => {
            wx.ready(function(){
                wx.onMenuShareTimeline({
                    title: initObj.title,
                    link: initObj.link,
                    imgUrl: initObj.imgUrl,
                    success: function () {
                        resolve();
                    }
                });
            });
        });
    },
    shareAppMessage(initObj){
        return new Promise((resolve, reject) => {
            wx.ready(function(){
                wx.onMenuShareAppMessage({
                    title: initObj.title,
                    desc: initObj.desc,
                    link: initObj.link,
                    imgUrl: initObj.imgUrl,
                    success: function () {
                        resolve();
                    }
                });
            });
        });
    },
    getLocation(){
        return new Promise((resolve, reject) => {
            wx.ready(function(){
                wx.getLocation({
                    type: 'wgs84',
                    success: function (res) {
                        resolve(res);
                    },
                    fail: function (res) {
                        reject(res);
                    }
                });
            });
        });
    },
    scanQRCode(){
        return new Promise((resolve, reject) => {
            wx.ready(function(){
                wx.scanQRCode({
                    needResult: 1,
                    scanType: ["qrCode","barCode"],
                    success: function (res) {
                        resolve(res);
                    },
                    complete: function (res) {
                        resolve(res);
                    }
                });
            });
        });
    },
    
}


// WEBPACK FOOTER //
// ./src/assets/js/wxsdk-wrapper.js